import { AffiliateFieldsFragment } from "api/generated";
import { AffiliatePayoutMethod } from "api/generated";
import * as iban from 'ibantools';

export const checkAffiliateInformationVerified = (
    affiliate: AffiliateFieldsFragment,
    payoutMethod: AffiliatePayoutMethod
  ) => {
    if (!affiliate) {
      return {
        isValid: false,
        missingFields: ['Address, company name, IBAN or NIF is missing']
      };
    }
  
    const missingFields: string[] = [];
  
    if (!affiliate.company?.name) {
      missingFields.push('Company name');
    }
    if (!payoutMethod?.details?.iban) {
      missingFields.push('IBAN');
    }
    if (!payoutMethod?.details?.nif) {
      missingFields.push('NIF');
    }
    if (!affiliate.address) {
      missingFields.push('Address');
    }
    if (!affiliate.meta_data?.tier) {
      missingFields.push('Tier');
    }
  
    // If we have missing fields, return them along with invalid status
    if (missingFields.length > 0) {
      return {
        isValid: false,
        missingFields
      };
    }
  
    // Validate IBAN
    const ibanWithoutSpaces = payoutMethod?.details?.iban?.replace(/\s/g, '');
    const isIbanValid = iban.isValidIBAN(ibanWithoutSpaces!);
    if (!isIbanValid) {
      return {
        isValid: false,
        missingFields: ['Invalid IBAN format']
      };
    }
  
    // Everything is valid
    return {
      isValid: true,
      missingFields: null
    };
  };

  export const checkPayoutMethodInformationVerified = (
    payoutMethod: AffiliatePayoutMethod
  ) => {
    if (!payoutMethod) {
      return {
        isValid: false,
        missingFields: ['IBAN or NIF is missing']
      };
    }

    const missingFields: string[] = [];
    
    if (!payoutMethod.details?.iban) {
      missingFields.push('IBAN');
    }
    if (!payoutMethod.details?.nif) {
      missingFields.push('NIF');
    }

    if (missingFields.length > 0) {
      return {
        isValid: false,
        missingFields
      };
    }

    // Validate IBAN
    const ibanWithoutSpaces = payoutMethod?.details?.iban?.replace(/\s/g, '');
    const isIbanValid = iban.isValidIBAN(ibanWithoutSpaces!);
    if (!isIbanValid) {
      return {
        isValid: false,
        missingFields: ['Invalid IBAN format']
      };
    }

    // Everything is valid
    return {
      isValid: true,
      missingFields: null
    };
  };